import React from "react";
import { Routes, Route } from "react-router-dom";

import "./App.css";
import { Footer } from "./components/Footer";
import { MercadoPagoSignUp } from "./pages/MercadoPagoSignUp";
import { MercadoPagoCallback } from "./pages/MercadoPagoCallback";
import { UpdateOrCreateMercadoPagoCredentials } from "./components/UpdateOrCreateMercadoPagoCredentials";
import { MercadoPagoErroCallbackInfo } from "./components/MercadoPagoErroCallbackInfo";

export const App = () => {
  console.log("init app");
  return (
    <div className="App">
      <img
        src="https://dashboard.rebill.to/images/bd71c46b16f6d52c9df51864dc337d1c.png"
        alt="Rebill Logo"
        width="500"
      />
      <Routes>
        <Route
          path="/auth/mercadopago/callback/:countryCode"
          element={<MercadoPagoCallback />}
        />
        <Route
          path="/mercadopago/link/success"
          element={<UpdateOrCreateMercadoPagoCredentials />}
        />
        <Route
          path="/mercadopago/link/rebillError"
          element={
            <MercadoPagoErroCallbackInfo rebillError={true} params={{}} />
          }
        />
        <Route
          path="/mercadopago/link/error"
          element={<MercadoPagoErroCallbackInfo />}
        />
        <Route path="/" element={<MercadoPagoSignUp />} />
      </Routes>
      <Footer />
    </div>
  );
};
